export interface Roles {
  name: string;
  role: string;
  roleName: string;
}

export class UserModels {
  public roles = [
    {
      name: 'Administrador',
      role: 'admin',
      roleName: 'ROLE_ADMIN',
    },
    {
      name: 'Mozo',
      role: 'waiter',
      roleName: 'ROLE_WAITER',
    },
    {
      name: 'Cajero',
      role: 'cashier',
      roleName: 'ROLE_CASHIER',
    },
    {
      name: 'Cocinero',
      role: 'chef',
      roleName: 'ROLE_CHEF',
    },
  ];
}
